// src/components/WhatsNew.js
import React from 'react';
import styled from 'styled-components';
import Lottie from "lottie-react";
import newAnim from "../Assets/icons/new.json";

const WhatsNew = ({ showWhatsNew, setShowWhatsNew }) => {
  return (
    <WhatsNewBox
      onMouseEnter={() => setShowWhatsNew(true)}
      onMouseLeave={() => setShowWhatsNew(false)}
    >
      {showWhatsNew && (
        <WhatsNewContent>
          <h4>What's New?</h4>
          <ul>
            <li>New Farmer Profiles Added</li>
            <li>Updated IA Training Data</li>
            <li>Dashboard Enhancements</li>
          </ul>
        </WhatsNewContent>
      )}

      <Lottie animationData={newAnim} loop={true} style={{ height: 50 }} />
      {!showWhatsNew && (
        <p>What's New?</p>
      )}
    </WhatsNewBox>
  );
};

export default WhatsNew;

// Styled components
const WhatsNewBox = styled.div`
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(242, 247, 241, 0.95);
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  max-width: 300px;
  z-index: 2;
`;

const WhatsNewContent = styled.div`
  h4 {
    margin: 0 0 8px 0;
    font-weight: 700;
    font-size: 1.1rem;
    color: #1b5e20;
  }

  ul {
    padding-left: 16px;
    margin: 0;
  }

  li {
    margin-bottom: 6px;
  }
`;
